import React from 'react';
import { EmptyState, EmptyStateBody } from '@patternfly/react-core';
import { CpuIcon } from '@patternfly/react-icons';

const VmHardwareTab: React.FunctionComponent = () => (
  <EmptyState
    titleText="Hardware details coming soon."
    icon={CpuIcon}
    variant="lg"
    headingLevel="h2"
    style={{ marginTop: '1rem' }}
  >
    <EmptyStateBody>CPU, memory, and disk allocation details will be displayed here.</EmptyStateBody>
  </EmptyState>
);

export default VmHardwareTab;
